module.exports = __webpack_public_path__ + "static/media/1.660f1830.png";